
let React = require("react");

let ApplicationContext = require("../../config/ApplicationContext.js");
let Utilities =          require("../../util/Utilities.js");
let LoginUtil =          require("../../util/LoginUtil.js");

let SubNavigationBar =   require("../../controls/SubNavigationBar.jsx");

let CardContainer =      require("../../controls/ListDataContainer.jsx"); //TODO (and check if ok to) rename listDataContainer to CardContainer
let GridLayoutSwitch =   require("../../controls/buttons/GridLayoutSwitch.jsx");
let SelectSort =         require("./../../controls/sort/SelectSort.jsx");

let LoadingPlaceholder = require("../../controls/cards/LoadingPlaceholder.jsx");

const SortMap = {
    "add": "updated_at%20desc",
    "az": "name%20asc",
    "za": "name%20desc"
};

class DataListPage extends React.Component {

    constructor() {
        super()
        this.state = {
            rows: 24, //Number of elements
            empty: false,
            layout: "",
            dataUrl: "",
            sort: SortMap["add"],
            pageIndex: 1,
            numElements: 0,
            updateView: false,
            doingSearch: false,
            dataError: false,
            user:{},
        };

        this.onSearch = this.onSearch.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.toggleLayout = this.toggleLayout.bind(this);
        this.onNumElements = this.onNumElements.bind(this);
        this.onPageChanged = this.onPageChanged.bind(this);
        this.updateDataOnceUserLogin = this.updateDataOnceUserLogin.bind(this); 
        this.renderUploadNewAssetOptions = this.renderUploadNewAssetOptions.bind(this); 

        this.updateView = this.updateView.bind(this);

        this.reloadTimer = null;
    }

    componentDidMount() {
        if(this.props.loginRequired){
            LoginUtil.checkLogin(this.updateDataOnceUserLogin);
        }else{
            this.updateDataOnceUserLogin()
            if(this.props.search) this.getContent(this.props)
        }

        this.setState({layout: this.props.defaultLayout || ApplicationContext.styleStore[this.props.urlName] || "list"});

        document.title = `${this.props.displayName} | library.io`;
    }

    componentWillReceiveProps(nextProps){
        const { search } = nextProps;
        if(search && search !== this.props.search){
            this.getContent(nextProps);
        }else if(!search){
            this.updateDataOnceUserLogin(nextProps)
        }

        document.title = `${nextProps.displayName} | library.io`;
    }

    getContent({endpoint, search = {url: ""}, filtersEndpoint = {}, doingSearch}){
        if(doingSearch) this.onPageChanged(1);

        let url = search.url;
        if(Object.keys(filtersEndpoint).length != 0){
            // not sure how to get here
            url = `q=${Utilities.escapeSpecialCharacters(search.value)}${this.addFilters(filtersEndpoint)}`;
        }
        this.setState({doingSearch: true, dataUrl: `${endpoint}?${url}${url ? "&" : ""}sort=${this.state.sort}`});
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }

    toggleLayout(style) {
        this.setState({ layout: style });
        ApplicationContext.styleStore[this.props.urlName] = style;
    };

    onPageChanged(pageIndex) {
        this.setState({ pageIndex });
        const url = Utilities.replaceQueryStringValue(window.location.href, "page", pageIndex, [1]);
        Utilities.updateBrowserHistoryUrl(undefined, `${this.props.urlName}, page: ${pageIndex}`, url);
    }

    /*customQuery comes from <SearchBox/> */

    updateDataOnceUserLogin(props = this.props, customQuery, 
                            pageIndex = Utilities.getQueryString(window.location.href, "page", 1),
                            doingSearch = false) {
        if(doingSearch) this.onPageChanged(pageIndex);

        let {endpoint: dataUrl, filtersEndpoint = {}} = props;

        if(customQuery) dataUrl = customQuery;
        
        dataUrl += this.addFilters(filtersEndpoint);
        this.setState({ "user": ApplicationContext.getUserData(), dataUrl, pageIndex, doingSearch});
    }

    
    addFilters(filters){
        return Object.entries(filters).reduce((accum, [name, val]) => {
            return accum += `&${name}=${val}`;
        }, "");
    }

    renderUploadNewAssetOptions(UploadNewAsset) {
        let toReset = this.props.resetViewAfterNewUpload;
        if(UploadNewAsset){
            return <UploadNewAsset 
                {...this.props}
                onUpload={
                    (message, id)=>this.props.setLoading(true, message, id)}
                onProgress={
                    (message, id)=>this.props.setLoading(true, message, id)}
                onComplete={
                    (id)=>{
                        this.props.setLoading(false, '', id);
                        if(toReset) this.updateView();
                    }
                }
                
            />
        }
    }

    updateView() {
        this.onPageChanged(1)
        this.setState({ updateView: !this.state.updateView});
    }

    onSelected(val){        
        const { endpoint, search: { url } } = this.props;

        const sort = SortMap[val] || this.state.sort;

        if(this.state.sort !== sort) this.onPageChanged(1);
        this.setState({dataUrl: `${endpoint}?${url}${url ? "&" : ""}sort=${sort}`, sort});
    }

    onNumElements(numElements, dataError){
        this.setState({numElements, dataError})
    }

    render() {
        const {defaultLayout="list", displayName, urlName, match, loginRequired, hasSearching = true, 
                showNumElements = false, showNav = true, hasSelectSort = false, hasGridLayoutSwitch = true, 
                onSetUrlLibraries = this.updateDataOnceUserLogin, showUploadNewAsset = true
            } = this.props;
        
        let gridStyle = this.state.layout !== "" ? this.state.layout : defaultLayout;
        
        if(!loginRequired || (this.state && this.state.user)) {

            return  <section className="container">
                        {showNav && <SubNavigationBar activeTab={urlName} match={match} search={hasSearching}
                            onSetUrlLibraries={onSetUrlLibraries} />}
                    
                        {(this.props.uploadContentIsAboveTitle && this.props.UploadNewAsset && showUploadNewAsset) 
                            && this.renderUploadNewAssetOptions(this.props.UploadNewAsset)}

                        <div className="section-title">
                            <h1 className="section-title__title">{displayName} 
                                                                {showNumElements && `(${this.state.numElements})`}
                                                                {this.state.dataError && <LoadingPlaceholder isError={true}/>}</h1>
                            {hasSelectSort && <SelectSort onSelected={this.onSelected}/>}
                            {hasGridLayoutSwitch && <GridLayoutSwitch onGridLayoutSwitchChanged={this.toggleLayout} layoutStyle={gridStyle} />}
                        </div>

                        {(!this.props.uploadContentIsAboveTitle && this.props.UploadNewAsset && showUploadNewAsset) 
                            && this.renderUploadNewAssetOptions(this.props.UploadNewAsset)}

                        <CardContainer
                            {...this.state}
                            {...this.props}
                            onNumber={this.onNumElements}
                            pageIndex={this.state.pageIndex - 1}
                            onPageChangeHandler={this.onPageChanged} 
                        />
                    </section>

        } else {
            return <div></div>
        }
    }
}

module.exports = DataListPage;
